<template lang="pug">
    b-modal(:id="'modal-cotization'" :visible="showModal" size="md" hide-footer @hide="handleModalClose" :no-close-on-backdrop="true")
      template(#modal-title)
        h5.modal-title Información de Pago ID {{ item.id }}
      div
        b-row
          b-col(cols="12").mb-3
            img(src="@/assets/icons/money.svg" alt="Acciones" style="width: 23px; height: 23px; margin-right: 8px")
            span.subtitle_montos Valores
          b-col(v-if="!inRejectedStatus" cols="12").d-flex.align-items-center
            b-form-checkbox( name="check-button" :checked="item.requiere_abono" disabled class="me-2")
            span Requiere Abono

          b-col(v-if="inRejectedStatus" cols="12").mb-2
            b-form-group(label="Costo de Envío" label-for="monto_envio")
              CurrencyInput(
                id="monto_envio"
                v-model="monto_envio"
                placeholder="Ingresa el costo de envío"
                :state="$v.monto_envio.$dirty ? !$v.monto_envio.$error : null"
              )
              b-form-invalid-feedback( v-if="!$v.monto_envio.$dirty || !$v.monto_envio.required")
                | Campo requerido

          b-col(cols="12")
            b-row
              b-col(v-if="!inRejectedStatus" cols="12").mt-2
                span.subtitle_montos Monto a Pagar (Total Final)
                span.float-right {{ montoTotalFinal || 0 | formatCurrency }}
              b-col(v-if="!inRejectedStatus" cols="12").mt-2
                span.subtitle_montos Monto Abonado
                span.float-right {{ item.monto_abonado || 0 | formatCurrency }}
              b-col(v-if="mostrarSaldoPendiente" cols="12").mt-2
                span.subtitle_montos Saldo Pendiente
                span.float-right {{ saldoPendiente | formatCurrency }}
              b-col(v-if="!inRejectedStatus" cols="12").mt-2
                span.subtitle_montos Descuento (aplicado)
                span.float-right {{`${item.monto_descuento > 0 ? '-' : ''} ${$options.filters.formatCurrency(item.monto_descuento)}`}}
              b-col(v-if="inRejectedStatus" cols="12").mb-2
                b-form-group(label="Valor Diagnóstico" label-for="monto_diagnostico")
                  CurrencyInput(
                    id="monto_diagnostico"
                    v-model="diagnosticValue"
                    placeholder="Valor diagnóstico"
                    :state="$v.diagnosticValue.$dirty ? !$v.diagnosticValue.$error : null"
                  )
                  b-form-invalid-feedback(v-if="$v.diagnosticValue.$error")
                    | El valor debe estar entre $0 y {{ MONTO_DIAGNOSTICO_ESTANDAR | formatCurrency }}
              b-col(v-if="inRejectedStatus" cols="12").mt-2
                span.subtitle_montos Costo de Envío
                span.float-right {{ monto_envio || 0 | formatCurrency }}
              b-col(cols="12").mt-2
                span.categoria_text Total a Pagar
                span.float-right {{ totalAPagar | formatCurrency }}
        b-row.mt-3
          b-col(cols="12")
            //- Selector de tipo de documento (Solo si hay monto a pagar)
            SelectorTipoDocumento(
              v-if="totalAPagar > 0"
              @datos-actualizados="onDatosDocumentoActualizados"
              :disabled="loading"
            )

            b-form-group
              label Comentario
              b-form-textarea(placeholder="Agrega algún dato de ser necesario" v-model="comentario"  class="textarea-height", id="comentario")
        b-button.float-left(variant="info" @click="closeModal") Cancelar
        b-button.float-right.d-flex.align-items-center.mb-3(
          variant="primary"
          id="boton-pagar-ov"
          :disabled="loading || (totalAPagar > 0 && !datosDocumento.valido)"
          @click="handlePayment"
        ) {{ totalAPagar > 0 ? 'Marcar como Pagado' : 'Marcar como cerrado' }}
          b-spinner.ml-2(v-if="loading" small)
    </template>

<script>
import { mapActions } from 'vuex'
import { requiredIf, between } from 'vuelidate/lib/validators'
import SelectorTipoDocumento from './SelectorTipoDocumento.vue'
import CurrencyInput from '../CurrencyInput.vue'

export default {
  name: 'ModalPayment',
  components: {
    SelectorTipoDocumento,
    CurrencyInput,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
    inRejectedStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comentario: '',
      MONTO_DIAGNOSTICO_ESTANDAR: 36490,
      diagnosticValue: 36490,
      monto_envio: null,
      loading: false,
      // Datos para tipo de documento
      datosDocumento: {
        tipo_documento: 'boleta',
        rut_contribuyente: null,
        valido: true,
      },
    }
  },
  computed: {
    montoTotalFinal() {
      if (!this.item || !this.item.resumen_montos) return 0
      return this.item.resumen_montos.monto_total_final || 0
    },
    totalAPagar() {
      if (this.inRejectedStatus) {
        return this.diagnosticValue + (this.monto_envio || 0)
      }
      const totalFinal = this.montoTotalFinal
      const abonado = this.item.monto_abonado || 0
      return Math.max(0, totalFinal - abonado)
    },
    saldoPendiente() {
      if (!this.item || !this.item.resumen_montos) return 0
      return this.item.resumen_montos.saldo_pendiente || 0
    },
    mostrarSaldoPendiente() {
      if (this.inRejectedStatus) return false
      if (!this.item) return false
      const monto_abonado = this.item.monto_abonado || 0
      const saldo = this.saldoPendiente
      return monto_abonado > 0 && saldo > 0
    },
  },
  validations() {
    return {
      monto_envio: {
        required: requiredIf(function () {
          return this.inRejectedStatus
        }),
      },
      diagnosticValue: {
        required: requiredIf(function () {
          return this.inRejectedStatus
        }),
        between: between(0, this.MONTO_DIAGNOSTICO_ESTANDAR),
      },
    }
  },
  methods: {
    ...mapActions('OVStore', ['sendPayment', 'crearExcepcion']),
    onDatosDocumentoActualizados(datos) {
      this.datosDocumento = datos
    },
    closeModal() {
      this.$emit('close')
    },
    handleModalClose() {
      this.closeModal()
    },
    async handlePayment() {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      // Validar que si es factura, el RUT esté validado (solo si hay monto a pagar)
      if (this.totalAPagar > 0 && !this.datosDocumento.valido) {
        this.$bvToast.toast(
          'Por favor valida el RUT del contribuyente antes de continuar',
          {
            variant: 'warning',
            solid: true,
          }
        )
        return
      }

      try {
        this.loading = true

        if (
          this.inRejectedStatus &&
          this.diagnosticValue < this.MONTO_DIAGNOSTICO_ESTANDAR
        ) {
          const payload = {
            id_oportunidad_venta: this.item.id,
            comentario:
              this.comentario ||
              `Descuento diagnóstico solicitado: ${this.$options.filters.formatCurrency(
                this.diagnosticValue
              )}`,
            tipo: 3,
            monto_minimo_solicitado: this.diagnosticValue,
          }
          const response = await this.crearExcepcion(payload)
          if (response.status === 201) {
            this.$bvToast.toast(
              'Solicitud enviada a aprobación. La OV quedará pendiente hasta que un superior la apruebe.',
              { variant: 'info', solid: true, title: 'Excepción creada' }
            )
            await new Promise((resolve) => setTimeout(resolve, 500))
            this.closeModal()
          }
          return
        }

        const payload = {
          comentario_cierre: this.comentario,
          id_oportunidad_venta: this.item.id,
          nro_boleta_pago: this.nro_boleta || null,
          monto_envio: this.monto_envio || 0,
          monto_diagnostico: this.inRejectedStatus
            ? this.diagnosticValue
            : null,
          tipo_documento: this.datosDocumento.tipo_documento,
        }

        // Agregar RUT contribuyente si es factura y hay monto a pagar
        if (
          this.totalAPagar > 0 &&
          this.datosDocumento.tipo_documento === 'factura' &&
          this.datosDocumento.rut_contribuyente
        ) {
          payload.rut_contribuyente = this.datosDocumento.rut_contribuyente
        }

        const response = await this.sendPayment(payload)
        if (response.status === 200) {
          this.$bvToast.toast(
            this.totalAPagar > 0
              ? 'Pago registrado.'
              : 'OV cerrada exitosamente.',
            {
              variant: 'success',
              solid: true,
            }
          )
          // Pequeño delay para asegurar que el backend procesó el pago
          await new Promise((resolve) => setTimeout(resolve, 500))
          this.closeModal()
        }
      } catch (error) {
        console.log(error)
        this.$bvToast.toast('Error al registrar pago.', {
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/colors.scss';

.btn-add-item {
  background-color: transparent !important;
  color: black !important;
  border: none !important;
  cursor: pointer;
}

.icon-add {
  color: #fece2f;
}

.trash-icon {
  color: #fece2f;
}

.form-subtitle {
  color: $samtek-black;
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding-left: 0.5em;

  > h3 {
    font-weight: bold;
    font-size: 18px;
    margin: 0;
  }

  + hr {
    margin: 0.5em 0 1.5em;
  }
}

.categoria,
.comentarios {
  display: block;
  font-size: 15px;
  font-weight: normal;
}

.comentario_text,
.categoria_text {
  color: var(--grey-textos-525252, #525252);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.subtitle_montos {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.title {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.textarea-height {
  height: 150px;
}
</style>
